export class AbstractHeaderComponent {
}
